import React, { FC } from 'react';
import { Form, useFormikContext } from 'formik';
import { useTranslation } from '@blocs.i18n';
import { FEATURE_FLAGS, useFeatureExperiment } from '@blocs.features-experiments';
import Label from '@minecraft.label';
import { FlexCol, BodyText, Link } from '@minecraft.atoms';
import FormikInput from '@minecraft.formik-input';
import Button from '@minecraft.button';
import { getEnvironment } from '@minecraft.environment';
import FormikPassword from '@minecraft.formik-password';
import { LoginFormValues } from 'src/modules/auth/forms/LoginMapper';
import { FieldStyles } from 'styles/Login.style';
import SCREEN_NAMES from 'config/constants/screenNames';

const LoginForm: FC<{ loading: boolean }> = ({ loading }) => {
  const { t } = useTranslation();
  const ULA_URL = getEnvironment()?.ULA_URL;
  const isLegacyOnboardingDeprecated = useFeatureExperiment(FEATURE_FLAGS.WEB_ONBOARDING_DEPRECATION);
  const { isValid, handleSubmit } = useFormikContext<LoginFormValues>();

  return (
    <Form>
      <FieldStyles data-testid="email-wrapper">
        <Label for="email">
          <BodyText fontWeight="semibold">
            {isLegacyOnboardingDeprecated
              ? t('common:form.label.emailAddressRequired')
              : t('common:form.label.usernameRequired')}
          </BodyText>
        </Label>
        <FormikInput name="email" id="email" type="text" data-qa-id={`${SCREEN_NAMES.LOGIN}-email`} />
      </FieldStyles>
      <FieldStyles data-testid="pw-wrapper">
        <Label for="password">
          <BodyText fontWeight="semibold">{t('common:form.label.passwordRequired')}</BodyText>
        </Label>
        <FormikPassword
          name="password"
          id="password"
          showText={t('common:button.show')}
          hideText={t('common:button.hide')}
          handleEnter={handleSubmit}
          data-qa-id={`${SCREEN_NAMES.LOGIN}-password`}
        />
      </FieldStyles>
      <div>
        <Link to={`${ULA_URL}/forgot-password`} data-qa-id={`${SCREEN_NAMES.LOGIN}-link-forgot-password`}>
          {t('login:login.forgotPassword')}
        </Link>
      </div>
      <FlexCol className="cn_w-full cn_mt-4" alignItems="stretch">
        <Button data-qa-id={`${SCREEN_NAMES.LOGIN}-submit-button`} isTall type="submit" disabled={!isValid || loading}>
          {loading ? t('common:button.loading') : t('common:button.login')}
        </Button>
      </FlexCol>
    </Form>
  );
};

export default LoginForm;
